import { motion } from "framer-motion";
import Backdrop from "../Backdrop";
import styles from '../../Donation.module.css'
const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 0,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: "100vh",
    opacity: 0,
  },
};
const ModalText = ({ text }) => (
  
  <div>
    <h3 className={styles.hh3}>Thanks for your support!</h3>
    <h5 className={styles.hh5}>
      Your support means that we can continue to maintain our app and provide you with the content that you love. Thank you!
    </h5>
  </div>
);

const Modal = ({ handleClose, text }) => {
  
  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        drag
        onClick={(e) => e.stopPropagation()}
        className={styles.modal}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <ModalText text={text} />
        <button className={styles.btn} onClick={handleClose}>Close</button>
        
      </motion.div>
    </Backdrop>
  );
};

export default Modal;
